import { getSupplierAccordions } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { toggleSupplierAccordion } from '@bridebook/web/app-basic/lib/supplier/supplier-details-slice';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useDispatch } from 'react-redux';
import { IAccordionProps } from '@bridebook/web/app-shared/components/supplier/sections/supplier-accordion/supplier-accordion';

export const useSupplierAccordion = () => {
  const dispatch = useDispatch();
  const accordionProps: IAccordionProps = {
    toggleSupplierAccordion: (name: string) => dispatch(toggleSupplierAccordion(name)),
    accordions: useSelector(getSupplierAccordions),
  };

  return accordionProps;
};
